<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12 ">
                <div class="card">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mr-auto">
                            <Link href="/roles/create" class="p-inputgroup-addon "><Button label="Tambah Role"
                                icon="pi pi-plus" /></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10"
                        :loading="datatable.loading" :total-records="datatable.totalRecords"
                        v-model:filters="datatable.filters"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5, 10, 25]"
                        current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data"
                        @page="onPage($event)" @sort="onSort($event)" @filter="onSort($event)">
                        <template #header>
                            <div class="table-header">
                                <h5 class="p-m-0 text-center">
                                    Daftar Role
                                </h5>
                            </div>
                        </template>
                        <Column field="id" header="ID" :sortable="false">
                            <template #body="slotProps">
                                {{ slotProps.data.number }}
                            </template>
                        </Column>
                        <Column field="name" header="Nama" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.name }}
                            </template>
                        </Column>
                        <Column field="kode" header="Kode" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.kode }}
                            </template>
                        </Column>
                        <Column field="permission" header="Permission" :sortable="false">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.permissions.length == 0">
                                    <span class="p-badge p-badge-danger">
                                        Belum punya permission
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-for="(permission, idx_permission) in slotProps.data.permissions"
                                        :key="idx_permission" class="p-badge p-badge-info">
                                        {{ permission }}
                                    </span>
                                </div>
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-info p-button-sm mr-1"
                                    @click="edit(slotProps.data.id)" v-if="slotProps.data.can.update" />
                                <Button icon="pi pi-trash" class="p-button-sm p-button-danger"
                                    @click="showDeleteDialog(slotProps.data)" />
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link
    },
    data() {
        return {
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {}
            },
            menuItems: [
                {
                    label: 'Tambah Role',
                    icon: 'pi pi-fw pi-plus',
                    class: 'p-button-primary p-button-raised',
                    command: () => {
                        this.$inertia.get(this.route('roles.create'));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters
        };
        this.loadLazyData();
    },
    methods: {
        console_log(param) {
            console.log(param);
        },
        loadLazyData() {
            this.datatable.loading = true;
            this.datatableService.getData(this.route('roles.datatable'), this.datatable.lazyParams).then(data => {
                this.datatable.data = data.data;
                this.datatable.totalRecords = data.total;
                this.datatable.loading = false;
            });
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
        },
        edit(id) {
            this.$inertia.visit(this.route('roles.edit', id), { preserveScroll: true });
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('roles.destroy', this.selectedModel.id), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
    }
}
</script>

<style scoped></style>
